<template>
    <div id="content-information">
        <div id="text-information">
            <span>
                <b>Código: </b>
                {{ station.simac_code }}
                <br>
            </span>

            <span>
                <b>Tipo de Estación: </b>
                {{ station.typology }}
                <br>
            </span>

            <span>
                <b>Red: </b>
                {{ station.net }}
                <br>
            </span>

            <span>
                <b>Latitud: </b>
                {{ latitude }}
                <br>
            </span>

            <span>
                <b>Longitud: </b>
                {{ longitude }}
                <br>
            </span>

            <span>
                <b>Altitud: </b>
                {{ station.altitude }} m.s.n.m
                <br>
            </span>

            <span>
                <b>Ubicación: </b>
                {{ station.location }}
                <br>
            </span>

            <span>
                <b>Municipio: </b>
                {{ station.municipality }}
                <br>
            </span>

            <span v-if="station.basin">
                <b>Cuenca: </b>
                {{ station.basin }}
                <br>
            </span>

            <span v-if="station.sub_basin">
                <b>Sub-Cuenca: </b>
                {{ station.sub_basin }}
                <br>
            </span>

            <span v-if="station.tare">
                <b>Tara: </b>
                {{ station.tare }}
                <br>
            </span>

            <span>
                <b>Propietario: </b>
                {{ station.owner_name }}
                <br>
            </span>

            <span>
                <b>Activa Desde: </b>
                {{ station.start_operation }}
                <br>
            </span>

            <span v-if="aforo">
                <b>Aforo: </b>
                <a :href="linkAforo" target="_blank">AFORO</a>
                <br>
            </span>

            <b>Detalle: </b>
            <span 
                v-if="hojaVida == ''" 
                style="color:rgb(236, 118, 118)"
            >
                Estación sin hoja de vida
            </span>
            <a 
                v-else target="_blank" 
                :href="hojaVida"
            >
                Hoja de vida
            </a>
            <br>
            <br>
            <span>
                Para más información, acceda a:
            </span>
        </div>
        <a 
            id="logo-cdiac"
            :href="linkCdiac" 
            target="_blank"
        >
            <img :src="logoCdiac">
        </a>
    </div>
</template>

<script>
    import queries from '@/services/links_queries.js';

    export default {
        name: "Information",

        data(){
            return{
                logoCdiac: require('@/assets/images/cdiac.svg'),
                linkCdiac: queries.cdiac,
                linkAforo: queries.aforo
            }
        },

        props: {
            station: [],
            hojaVida: String,
            aforo: Boolean
        },

        /*
        * convertir longitud y latitud de decimal a grados, minutos y segundos
        */

        computed: {
            latitude(){
                let latitud = Math.abs(parseFloat(this.station.latitude));
                let grades = Math.floor(latitud * 1);
                let minutes = Math.floor((latitud - grades)*60);
                let seconds = ((((latitud - grades) * 60) - minutes) * 60);

                if(this.station.latitude > 0){
                    return grades + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'N';
                }else{
                    return grades + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'S';
                }
            },

            longitude(){
                let longitud = Math.abs(parseFloat(this.station.longitude));
                let grades = Math.floor(longitud * 1);
                let minutes = Math.floor((longitud - grades)*60);
                let seconds = ((((longitud - grades) * 60) - minutes) * 60);

                if(this.station.longitude > 0){
                    return grades + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'E';
                }else{
                    return grades + "° " + minutes + "' " + seconds.toFixed(1) + "'' " + 'W';
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    #content-information{
        margin: 1em;

        #logo-cdiac{
            height: 2.5em;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid cornflowerblue;
            padding: .2em;

            img{
                height: 100%;
            }
        }

        #logo-cdiac:hover{
            background-color:rgba(100, 149, 237, 0.5);
        }
    }
</style>